import type { SamplesOrderLocationCartState } from '../SamplesOrders.types'

export const isSamplesOrderLocationCartState = (
  state: unknown,
): state is SamplesOrderLocationCartState => {
  if (!state || typeof state !== 'object') return false

  return 'cart' in state
}
